import GameFactModelDTO from "./conf/GameFactModelDTO.js"

const stub = {
    "entries": [
      {
        "label": "France",
        "position": 1,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 10, "position": 1 },
          { "name": "medal", "value": "silver", "count": 5, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 7, "position": 3 }
        ]
      },
      {
        "label": "Norvège",
        "position": 2,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 14, "position": 1 },
          { "name": "medal", "value": "silver", "count": 3, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 4, "position": 3 }
        ]
      },
      {
        "label": "Allemagne",
        "position": 3,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 8, "position": 1 },
          { "name": "medal", "value": "silver", "count": 10, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 12, "position": 3 }
        ]
      },
      {
        "label": "Ecosse",
        "position": 4,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 6, "position": 1 },
          { "name": "medal", "value": "silver", "count": 8, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 10, "position": 3 }
        ]
      },
      {
        "label": "Etats-Unis",
        "position": 5,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 15, "position": 1 },
          { "name": "medal", "value": "silver", "count": 10, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 5, "position": 3 }
        ]
      },
      {
        "label": "Canada",
        "position": 6,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 3, "position": 1 },
          { "name": "medal", "value": "silver", "count": 12, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 15, "position": 3 }
        ]
      },
      {
        "label": "Italie",
        "position": 7,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 7, "position": 1 },
          { "name": "medal", "value": "silver", "count": 6, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 9, "position": 3 }
        ]
      },
      {
        "label": "Chine",
        "position": 8,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 18, "position": 1 },
          { "name": "medal", "value": "silver", "count": 2, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 1, "position": 3 }
        ]
      },
      {
        "label": "Russie",
        "position": 9,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 9, "position": 1 },
          { "name": "medal", "value": "silver", "count": 14, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 6, "position": 3 }
        ]
      },
      {
        "label": "Japon",
        "position": 10,
        "gameFacts": [
          { "name": "medal", "value": "gold", "count": 5, "position": 1 },
          { "name": "medal", "value": "silver", "count": 14, "position": 2 },
          { "name": "medal", "value": "bronze", "count": 6, "position": 3 }
        ]
      },
    ]
}

class ClassementDTO {

  //constructor(classementData = stub){
    constructor(classementData){
        if(!classementData)
            return

        const { entries, models } = classementData

        this.entries = entries?.map(entry => new Entry(entry))
        this.gamefactModels = models?.map(model => new GameFactModelDTO(model))
    }
}

class Entry {

    constructor(entryData){
        if(!entryData)
            return

        const { label, position, gameFacts } = entryData

        this.label = label
        this.position = position
        this.gameFacts = gameFacts.map(gf => new GameFact(gf))
    }
}

class GameFact {

    constructor(gamefactData){
        if(!gamefactData)
            return

        const { value, count, position, name } = gamefactData

        this.name = name
        this.value = value
        this.count = count
        this.position = position
    }
}

export default ClassementDTO